import Span from 'src/components/atomic/atom/Span'
import { COLOR } from 'src/constants/colors'
import Button from 'src/components/atomic/atom/Button'
import { ColorHandler } from 'src/utils/style.utils'
import { HomeDataPropsType } from 'src/views/Service/Home'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import Div from 'src/components/atomic/atom/Div'
import CountryPhoneInput from 'src/components/etc/CountryPhoneInput'
import Spinner from 'src/components/atomic/atom/Spinner'

const HomeEmergencyContact = (props: { data: HomeDataPropsType }) => {
  const { onEmergencyContactSubmit } = props.data
  const { t } = useTranslation()
  const { setMediaStyle } = useMediaQueryHook()
  const { Connection } = useAppSelector((state: RootState) => state.connection)
  const { TempValue, CountryCode } = useAppSelector((state: RootState) => state.HomePage)

  return (
    <>
      <Span option="title" $margin={setMediaStyle('0 0 4.5px 0', '0 0 7.5px 0', '0 0 7.5px 0')}>
        {t('HOME.CONTACT_TITLE', { defaultValue: 'Emergency contact' })}
      </Span>
      <Span option="tiny" $text_align={'left'} color={COLOR.black70} $margin={'0 0 12px 0'}>
        {t('HOME.CONTACT_DESC', 'You may receive calls from the one who picked up your device.')}
      </Span>
      <Div
        width={'100%'}
        height={setMediaStyle('211px', '194px', '198px')}
        style={{ position: 'relative' }}
      >
        {CountryCode === null ? (
          <Spinner />
        ) : (
          <>
            <CountryPhoneInput />
            <Button
              $tabIndex={0}
              id={'country'}
              className={'country'}
              option={'bigDefault'}
              $bgColor={ColorHandler(
                Connection && (TempValue.GPNumber.length as number) > 6,
                'brand_black10',
              )}
              $margin={setMediaStyle('0 0 40px 0', '12px 0 24px 0', '12px 0 28px 0')}
              disabled={!Connection || TempValue.GPNumber.length < 7}
              onClick={onEmergencyContactSubmit}
            >
              <Span
                option={'medium_bold'}
                color={ColorHandler(Connection && TempValue.GPNumber.length > 6, 'white_black30')}
                className={'country'}
              >
                {t('BUTTON.SAVE', { defaultValue: 'Save' })}
              </Span>
            </Button>
          </>
        )}
      </Div>
    </>
  )
}

export default HomeEmergencyContact
